import { useContext } from "react";
import { ApplicationTableResourceContext } from "./ApplicationTableResourceProvider";

export const useApplicationTableResourceContext = () => useContext(ApplicationTableResourceContext);

export default useApplicationTableResourceContext;
